import Fieldset from "@/components/Fieldset";
import { DateRangeField } from "@/modules/projects/components/schedules/fields/DateRangeField";
import { DurationKamField } from "@/modules/projects/components/schedules/fields/DurationKamField";
import { EverySecondWeekField } from "@/modules/projects/components/schedules/fields/EverySecondWeekField";
import { HourAllocationTypeField } from "@/modules/projects/components/schedules/fields/HourAllocationTypeField";
import { ProjectRoleField } from "@/modules/projects/components/schedules/fields/ProjectRoleField";
import { RoundingField } from "@/modules/projects/components/schedules/fields/RoundingField";
import { SettlementTypeField } from "@/modules/projects/components/schedules/fields/SettlementTypeField";
import { TimeRangeField } from "@/modules/projects/components/schedules/fields/TimeRangeField";
import { WeekdaysField } from "@/modules/projects/components/schedules/fields/WeekdaysField";
import { memo } from "react";

const ProjectSchedulesAddSchedulesDialogFormComponent = () => {
  return (
    <>
      <Fieldset className="mb-6 mt-0">
        <ProjectRoleField />
      </Fieldset>
      <Fieldset className="grid grid-cols-1 lg:grid-cols-2 m-0">
        <DateRangeField required />
      </Fieldset>
      <Fieldset className="flex flex-col md:flex-row gap-4 items-end m-0">
        <DurationKamField required />
        <TimeRangeField />
      </Fieldset>
      <Fieldset className="grid grid-cols-1 lg:grid-cols-2 gap-6 m-0">
        <div className="flex flex-col gap-2">
          <HourAllocationTypeField required />
          <RoundingField />
        </div>
        <SettlementTypeField required />
      </Fieldset>
      <Fieldset className="my-0 border border-gray-200 rounded-lg p-2 items-start">
        <WeekdaysField />
      </Fieldset>
      <Fieldset className="mb-6 mt-0 ml-2">
        <EverySecondWeekField />
      </Fieldset>
    </>
  );
};

export const ProjectSchedulesAddSchedulesDialogForm = memo(
  ProjectSchedulesAddSchedulesDialogFormComponent,
);
